import React from "react";
import { BiArrowBack } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import { listBackPath } from "../Helpers/useListParams";

// With a url (a list page), Back returns to that list as the user last left it - same page number
// and filters (see useListParams). Without one it is plain browser Back.
const BackButton = ({ label = "Back", className = "", name = "", url = "" }) => {
    const navigate = useNavigate();
    const handleBack = () => (url ? navigate(listBackPath(url)) : navigate(-1));

    return (
        <button
            type="button"
            className={`btn box-shadow py-1 px-3 d-flex align-items-center fs-6 gap-2 ${className} back-btn`}
            onClick={handleBack}
        >
            <BiArrowBack />
            {label} {name}
        </button>
    );
};

export default BackButton;
